"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var darkTheme = function (_breakpoints) {
    return ({
        palette: { type: 'dark' }
    });
};
exports.default = darkTheme;
//# sourceMappingURL=index.js.map